import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-svg-arrow",
  "use": "tc-svg-arrow-usage",
  "viewBox": "0 0 35 7",
  "content": "<symbol viewBox=\"0 0 35 7\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tc-svg-arrow\">\n\t<path d=\"M35 3.5L30 0.613249V6.38675L35 3.5ZM0 4L30.5 4V3L0 3L0 4Z\" fill=\"var(--icon-color, #000)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol